import * as React from 'react';
import type { SVGProps } from 'react';

const SvgQuotesArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 541 909" {...props}>
    <path
      fillRule="evenodd"
      d="M533.98 499.79c5.198-16.402 7.369-33.265 6.975-49.997-.593-12.055-2.172-24.176-5.593-36.23-10.33-37.548-34.807-71.011-71.456-92.156L-57.541 20.565C-131.168-21.79-224.996 3.373-267.238 76.821c-42.637 73.382-17.502 167.053 56.126 209.475L80.306 454.667l-291.418 167.91c-73.628 42.554-98.697 136.225-56.126 209.871 42.242 73.251 136.07 98.282 209.697 55.992l521.447-301.105c35.201-20.157 59.086-51.907 70.074-87.545Z"
      clipRule="evenodd"
      opacity={0.2}
    />
  </svg>
);

export default SvgQuotesArrow;
